import moment from 'moment';
import { getFixedValue } from '../currencyConvertion';

export function getBillingDetails({ checkIn, checkOut, bookingSpecialPricing, basePrice, total, hostServiceFee, guestServiceFee }) {

    let momentStartDate, momentEndDate, dayDifference = 0, isSpecialPricingAssigned = false, dayPrice = 0, hostSubTotal = 0;
    let isAverage = 0, hostTotal = 0, guestTotal = 0, isDayTotal = 0;
    isSpecialPricingAssigned = bookingSpecialPricing?.length > 0 ? true : false;

    if (checkIn && checkOut) {
        momentStartDate = moment(checkIn);
        momentEndDate = moment(checkOut);
        dayDifference = momentEndDate.diff(momentStartDate, 'days');
        if (isSpecialPricingAssigned) {
            bookingSpecialPricing?.map((item, index) => {
                dayPrice = dayPrice + Number(item?.isSpecialPrice);
            });
        } else {
            dayPrice = basePrice * dayDifference;
        }
    }

    isAverage = getFixedValue(Number(dayPrice) / Number(dayDifference));
    isDayTotal = isAverage * dayDifference;
    dayPrice = isDayTotal;

    hostTotal = total - hostServiceFee;
    guestTotal = total + guestServiceFee;
    hostSubTotal = total;

    return {
        isAverage,
        dayPrice,
        hostTotal,
        guestTotal,
        dayDifference,
        isSpecialPricingAssigned,
        hostSubTotal
    };
};
